<!-- Main Page Start -->
<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  
  <div class="right-panel lang">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="topHeader">
              <h2 class="pageTitle">Add Languages   <a href="javascript:void(0);" class="addMoreBtn"  (click)="addNewLanguageGroup()"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More </a></h2>
              <a href="javascript:void(0)" routerLink="/jobs" class="skipBtn"> Skip </a>
          </div>
          <div formArrayName="languageProficiency">
            <div class="row" *ngFor="let skill of getLanguagesArray(); let i=index">
                <div class="col-md-6 col-lg-6  col-sm-12" [formGroupName]="i">
                    <div class="form-group">
                        <label>Language<span class="orangeText">*</span> </label>
                        <!-- <input type="text"  class="form-control upper" placeholder="Spanish" formControlName="language" > -->
                        <ng-multiselect-dropdown  formControlName="language" class="form-control noBorder px-0" [placeholder]="'Select'" [settings]="dropdownLanguageSettings" [data]="Languages"></ng-multiselect-dropdown>
                        <div class="text-danger" *ngIf="checkLanguageEmpty(i) && showError">
                            *Please enter language.
                        </div>
                        <div class="text-danger" *ngIf="checkLanguageDuplicate(i) && showError">
                            *Please enter different language.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 " [formGroupName]="i">
                    <div class="form-group">
                        <label>Proficiency<span class="orangeText">*</span> </label> 
                        <select  class="form-control" placeholder="Select Proficiency" formControlName="proficiency">
                            <option value="Read">Read</option>
                            <option value="WriteRead">Write and read</option>
                            <option value="Speak">Speak</option>
                            <option value="NativeBilingual">Native or bilingual</option>
                        </select>
                        <div class="text-danger"  *ngIf="checkProficiencyEmpty(i) && showError">
                            *Please enter proficiency.
                        </div>
                    </div>
                </div> 
                <div class="col-md-12 col-sm-12 ">
                    <a  href="javascript:void(0)" *ngIf="i>0" (click)="deleteLanguage(i)" title="Delete" class="text-right"><img src="../../../../assets/images/ic_delete.svg"> </a>
                </div>
            </div>
            <div class="form-group bottom ">
                <input type="submit" value="Save"  class="commonBtn width50 mt-2">
            </div>
        </div>
      </form>
  </div>
</section>